<template>
    <div v-cloak>
        <div
            v-for="(events, index) in month_events"
            :class="{
                'events-group': true
            }"
        >
            <div
                :class="{
                    'events-group-header': true
                }"
            >
                <div class="events-group-header-icon">
                    <span>{{ get_date(i)[0] }}</span>
                </div>
                {{ get_date(i) }}
            </div>
            <a class="events-group-item" v-if="events && events.length > 0" v-for="_event in events">
                <div class="events-group-item-header">
                    <span style="max-width: 92%;" @click="go_to_event(_event.id)">{{ _event.name }}</span>
                    <div class="action">
                        <div class="checkbox">
                            <input @change="check_changed(_event.id, $event)" :id="_event.id" type="checkbox" />
                            <label :for="_event.id"></label>
                        </div>
                    </div>
                </div>
                <div class="events-group-item-content" @click="go_to_event(_event.id)">
                    <div class="events-group-item-content--date" v-if="_event.time">
                        {{ moment(_event.time).format("dd")[0] }}
                        {{ moment(_event.time).format("DD.MM, HH:mm") }}
                    </div>
                    <div v-if="_event.guests && _event.guests.length > 0" class="events-group-item-content--attending">
                        Attending {{ get_attending_count(_event.guests) }}/{{ _event.guests.length }}
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import router from "@/router";

export default {
    props: ["month_events", "i"],
    data() {
        return {};
    },
    computed: {},
    methods: {
        ...mapMutations("StorePeople", ["set_event_ids"]),
        get_date(date) {
            let time_date = moment(date, "MM.YYYY");
            return moment(time_date).format("MMMM YYYY");
        },
        go_to_event(ev) {
            router.push({ path: "/events/" + ev });
        },
        check_changed(data, event) {
            this.$emit("changed", { event, data });
        },
        get_attending_count(guests) {
            let _guests = guests.find(el => el.status === "attending");
            if (_guests && _guests.length > 0) {
                return _guests.length;
            } else {
                return 0;
            }
        }
    }
};
</script>

<style scoped>
.action {
    right: -1.2rem;
    position: absolute;
    bottom: -0.2rem;
}
</style>
